import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  RelationsListComponent,
  RelationFormComponent,
  RelationsReorderComponent
} from '../upgrade/relations.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const relationsRoutes: Routes = [
  {
    path: 'relations',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'relations.view'
    },
    children: [
      {
        path: '',
        component: RelationsListComponent,
        data: {
          state: 'epf.relations.index'
        }
      },
      {
        path: 'new',
        component: RelationFormComponent,
        canActivate: [authGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'relations.edit',
          state: 'epf.relations.new'
        }
      },
      {
        path: 'edit/:id',
        component: RelationFormComponent,
        canActivate: [authGuard],
        data: {
          permission: 'relations.edit',
          state: 'epf.relations.edit'
        },
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'reorder',
        component: RelationsReorderComponent,
        canActivate: [authGuard],
        data: {
          permission: 'relations.edit',
          state: 'epf.relations.reorder'
        }
      }
    ]
  }
];
